<template>
  <flat-pickr
    :value="v"
    :config="config"
    :placeholder="placeholder"
    :name="name"
    @on-change="onChange">
  </flat-pickr>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'flatpickr/dist/themes/airbnb.css'
import {Norwegian} from 'flatpickr/dist/l10n/no.js'

export default {
  name: 'date-picker',
  components: {
    flatPickr
  },
  props: ['value', 'placeholder', 'name'],
  data () {
    return {
      v: null,
      config: {
        // wrap: true, // set wrap to true only when using 'input-group'
        minDate: 'today',
        //weekNumbers: true,
        altFormat: 'j. F Y',
        altInput: true,
         //dateFormat: 'yyyy-dd-DD',
        locale: Norwegian, // locale for this instance only
      }
    }
  },
  methods: {
    twoDigitPad(num) {
      return num < 10 ? "0" + num : num;
    },
    onChange (val) {
      const dt = val[0]
      const s = dt.getFullYear() + '-' + this.twoDigitPad(dt.getMonth() + 1) + '-' + this.twoDigitPad(dt.getDate())
      this.$emit('input', s)
    }
  },
  created () {
    this.v = this.value
  }
}
</script>